var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19.7206L9.10794 22.09L16.0769 18.1077L22 20.4769V4.32286L15.9231 1.89209L8.89206 5.90982L2 3.61246V19.7206ZM14 16.991L10 19.2767V7.58021L14 5.2945V16.991ZM16 15.9229L20 17.5229V5.67692L16.0769 4.10769L16 4.15164V15.9229ZM4 18.2791L8 19.6125V7.72065L4 6.38731V18.2791Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLink);
export default __webpack_public_path__ + "static/media/map_link.c9dca0b7.svg";
export { ForwardRef as ReactComponent };